import React, { useState, useEffect } from 'react';
import { SystemInfoHeader } from '../../organisms/system/systemInfoHeader/SystemInfoHeader';
import { HtmlTextSection } from '../../organisms/shared/htmlTextSection/HtmlTextSection';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import { getDataByType } from '../../../utils/utils';
import { Breadcrumbs } from '../../molecules/shared/breadcrumbs/Breadcrumbs';
import AlternativesList from '../../organisms/system/alternativesList/AlternativesList';
import ShortcutsBar from '../../organisms/system/shortcutsBar/ShortcutsBar';
import Footer from '../../organisms/shared/footer/Footer';
import Header from '../../organisms/shared/header/Header';

export const SystemAlternatives = ({
  sections,
  hero,
  breadcrumbs,
  t,
  locale,
  menu,
  footer,
  siteUrls,
  location,
  search,
  handleDataLayer,
  customer,
  systemNameUrl,
}) => {
  const headerSection = getDataByType(sections, 'header');
  const alternatives = getDataByType(sections, 'alternatives');

  const [defaultScrolled, setDefaultScrolled] = useState(false);

  useEffect(() => {
    if (!defaultScrolled) {
      window.scrollTo({
        top: 300,
        behavior: 'instant',
      });

      setDefaultScrolled(true);
    }
  });

  const buttonTitles = [
    {
      title: t('sp.whyChooseCompany', { companyName: hero.companyName }),
      href: `${systemNameUrl}#why`,
    },
    { title: t('sp.reviews'), href: `${systemNameUrl}#reviews` },
    { title: t('sp.functions'), href: `${systemNameUrl}#functions` },
    {
      title: t('sp.alternative'),
      href: '#',
    },
  ];
  const buttonTitlesUnpaid = [
    {
      title: t('sp.reviews'),
      href: `${systemNameUrl}#reviews`,
    },
    {
      title: t('sp.functions'),
      href: `${systemNameUrl}#functions`,
    },
    {
      title: t('sp.comparisons'),
      href: `${systemNameUrl}#comparisons`,
    },
    {
      title: t('sp.alternative'),
      href: '#',
    },
  ];

  const scrollToSection = (id) => {
    switch (id) {
      case 1:
        // navigate to /system/{systemName}/#why
        break;
      case 2:
        // nothing or scrollToTop
        break;
      case 3:
        // navigate to /system/{systemName}/#functions
        break;
      case 4:
        // navigate to /system/{systemName}/#comparisons
        break;

      default:
        break;
    }
  };

  return (
    <div className="bg-white overflow-x-hidden">
      <NavigationBar
        data={menu}
        location={location}
        locale={locale}
        search={search}
        t={t}
      />
      <Header minimized />
      <main>
        <SystemInfoHeader section={headerSection} isPaid={customer} t={t} />
        <div className="h-auto w-full bg-primary-50 pt-10 pb-5">
          <ShortcutsBar
            fixed={false}
            onPress={scrollToSection}
            scrollPosition={4}
            buttonTitles={customer ? buttonTitles : buttonTitlesUnpaid}
            className="!mb-0 !-mt-10"
          />
          <Breadcrumbs levels={breadcrumbs} infoText={t('legal.system.text')} />
          <HtmlTextSection
            section={hero.description}
            className="!max-w-2xl !my-4"
            textClassName="text-center"
          />
        </div>
        <AlternativesList section={alternatives} t={t} />
      </main>
      <Footer data={footer} siteUrls={siteUrls} />
    </div>
  );
};

SystemAlternatives.propTypes = {};
